import React, { useContext, useState, useRef } from "react";

export const DentalInsuranceContext = React.createContext(null);

export const DentalInsuranceProvider = ({ children }) => {
  const [showInsuranceTray, setShowInsuranceTray] = useState(false);
  const [open, setOpen] = useState(false);
  const [insuranceSearch, setInsuranceSearch] = useState("");

  const buttonClick = useRef(false);

  return (
    <DentalInsuranceContext.Provider
      value={{ showInsuranceTray, setShowInsuranceTray, buttonClick ,open, setOpen, insuranceSearch, setInsuranceSearch}}
    >
      {children}
    </DentalInsuranceContext.Provider>
  );
};

export const useDentalInsuranceContext = () => {
  const context = useContext(DentalInsuranceContext);
  if (!context) {
    throw new Error(
      "useDentalInsuranceContext must be used within a DentalInsuranceContext"
    );
  }

  return context;
};
